// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3UAp9","title":"Info_title__2Haoq","selects":"Info_selects__2PoYD","requiredAsterisk":"Info_requiredAsterisk__3b3O7"};